<template>
  <custom-dialog width="1100px" :title="model.title" v-on="$listeners" :visible="visible" class="invoice-record-dialog" :append-to-body="true">
    <div class="dialog-body">
      <div class="table-content">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent class="fr">
            <!-- <el-form-item style="float:right; margin-right: 0 !important;">
              <el-button type="info"><i class="icon icon-export-excel "></i> 导出 Excel</el-button>
            </el-form-item> -->
            <el-form-item style="float: right; margin-right: 0 !important">
              <search-input v-model="formSearch.keyword" :placeholder="$t('invoiceRecordDialog.fa_piao_bian_hao')"></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table :tableCode="tableCode" height="350px" :data="fuzzyQueryTableList" @filter="filterChange" @sort="sortChange" :slots="['invoiceNum', 'invoiceType']">
            <template v-slot:invoiceType="scope">
              {{getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass)}}
            </template>
            <template v-slot:invoiceNum="scope">
              <span class="invoice-num line" v-if="scope.row.invoiceNum" @click="checkInvoiceDetail(scope.row)">{{ scope.row.invoiceNum }}</span>
              <span class="invoice-num" v-else>-</span>
            </template>
          </custom-table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" plain @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
    </div>
    <invoice-details-dialog v-if="invoiceDetailsVisible" @close="invoiceDetailsVisible = false" :model="invoiceDetailsModel"></invoice-details-dialog>
  </custom-dialog>
</template>

<script>
/** 发票记录 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import invoiceDetailsDialog from '@/pages/myAccount/children/invoice_details_dialog.vue';
import invoiceTypeMixins from '@/utils/invoice_type_mixins.js';

export default {
  name: 'invoiceRecordDialog',
  mixins: [dialogMixins, invoiceTypeMixins],
  components: {
    invoiceDetailsDialog,
  },
  props: {},
  computed: {
    fuzzyQueryTableList() {
      return this.fuzzyQuery(this.tableList, ['invoiceNum'], this.formSearch.keyword);
    },
  },
  data() {
    return {
      // 表格列：portal_invoice_record_dialog
      // 开票日期-invoiceTime 发票编号-invoiceNum
      // 发票类型-invoiceType:invoice_type 发票金额-invoiceAmount 发票抬头-buyerName 销售方-sellerName
      tableCode: 'portal_invoice_record_dialog',
      formSearch: {
        keyword: '',
      },
      totalRows: 0,
      tableList: [],
      billId: '',
      invoiceDetailsModel: {},
      invoiceDetailsVisible: false,
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.$getJSON(`${apis.portalBillInvoiceDetail}/${this.billId}`).then((res) => {
        this.tableList = res.data;
      });
    },
    checkInvoiceDetail(row) {
      this.invoiceDetailsModel = {
        title: this.$t('invoiceRecordDialog.cha_kan_fa_piao'),
        billId: row.billId,
        invoiceId: row.invoiceId,
      };
      this.invoiceDetailsVisible = true;
    },
  },
  mounted() {
    this.billId = this.model.billId;
    this.getCompDictionary(() => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss">
.invoice-record-dialog {
  .el-dialog__body .dialog-body {
    padding-top: 0 !important;
  }
  .el-form-item {
    margin-right: 16px !important;
  }

  .invoice-num {
    &.line {
      color: #33b3e1;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
